"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Input = _interopRequireDefault(require("./Input"));

var _FormItemProvider = _interopRequireDefault(require("../Utility/FormItemProvider"));

var _PlusIcon = _interopRequireDefault(require("../Icons/PlusIcon"));

var _MinusIcon = _interopRequireDefault(require("../Icons/MinusIcon"));

var _I18nManager = _interopRequireDefault(require("../../../managers/I18nManager"));

var _PropTypesUtils = require("../../../utils/PropTypesUtils");

var _ThemeManager = _interopRequireDefault(require("../../../managers/ThemeManager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var InputWithLabel = (0, _FormItemProvider.default)(_Input.default);
/**
 * Check if the value is either null or undefined.
 * @param {any} value - the value to check
 * @returns {boolean} - true if value is null or undefined else false.
 */

function isNil(value) {
  var valueType = _typeof(value);

  return value === null || valueType === 'undefined';
}
/**
 * This is a component to provide input of a number.
 * This component is a wrapper around FormItemProvider and Input components,
 * there for all properties in those component can be used here.
 */


var InputNumber =
/*#__PURE__*/
function (_React$Component) {
  _inherits(InputNumber, _React$Component);

  function InputNumber(props) {
    var _this;

    _classCallCheck(this, InputNumber);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(InputNumber).call(this, props));

    _initialiseProps.call(_assertThisInitialized(_this));

    _this.state = _objectSpread({}, _this._getInitState());
    _this.prevValidValue = _this.state.value;
    return _this;
  }
  /**
   * Get the initValue based on the given value.
   *
   * @param {number | string} value -  must not be undefined.
   * @private
   * @return {string} - '' | string in a form of a number
   */


  _createClass(InputNumber, [{
    key: "_getInitValueHelper",
    value: function _getInitValueHelper(value) {
      if (typeof value === 'number') {
        return value.toString();
      } else if (isFinite(value)) {
        return value;
      }

      return '';
    }
    /**
     * This is a helper function for the constructor to set the initial state.
     * @param {string | number } value - The input value
     * @param {string | number } defaultValue - The input value
     * @private
     * @return { object } - state object.
     */

  }, {
    key: "_getInitState",
    value: function _getInitState() {
      var _this$props = this.props,
          value = _this$props.value,
          defaultValue = _this$props.defaultValue;
      var state = {}; // Both value and defaultValue are undefined/null

      if (isNil(value) && isNil(defaultValue)) {
        // uncontrolled
        state.controlled = false;
        state.value = '';
        state.error = false;
        state.helpText = undefined;
        return state;
      } // value is null/undefined && defaultValue is defined.


      if (isNil(value) && !isNil(defaultValue)) {
        // uncontrolled
        state.controlled = false;
        state.value = this._getInitValueHelper(defaultValue);
        state.error = !this._isValidRange(state.value);
        state.helpText = state.error ? this._getInvalidRangeHelpText() : undefined;
        return state;
      } // value is defined && defaultValue is null/undefined or
      // value is defined && defaultValue is also defined.
      // controlled


      state.controlled = true;
      state.value = this._getInitValueHelper(value);
      return state;
    }
    /**
     * @override
     * @param {object} props - next Props
     * @param {object} state - current state
     * @return {object|null} new state object or null if current state is valid.
     */

  }, {
    key: "_addOrMinus",

    /**
     * This is a helper function to increase or decrease a current
     * value.
     * @param {number} step : use negative number to decrease and
     *   positive number to increase.
     * @private
     */
    value: function _addOrMinus(step) {
      var value = this.state.value;
      var _this$props2 = this.props,
          min = _this$props2.min,
          max = _this$props2.max;
      var newNumber;

      if (value === '') {
        newNumber = step;
      } else {
        newNumber = parseFloat(value) + step;
      }

      if (newNumber > max) {
        newNumber = max;
      } else if (newNumber < min) {
        newNumber = min;
      }

      this._setStateValue(newNumber.toString());
    }
    /**
     * Helper function to set the new state.
     * @param {string} value - value
     * @private
     */

  }, {
    key: "_setStateValue",
    value: function _setStateValue(value) {
      var onValueChange = this.props.onValueChange;

      if (!isFinite(value)) {
        return;
      }

      var error = !this._isValidRange(value);
      var helpText = error ? this._getInvalidRangeHelpText() : undefined;

      if (!this.state.controlled) {
        this.setState({
          value: value,
          error: error,
          helpText: helpText
        });
        this.prevValidValue = value;
      } else if (this.state.value === '-') {
        this.setState({
          value: this.prevValidValue
        });
      }

      if (onValueChange) {
        onValueChange(value, error, helpText);
      }
    }
    /**
     * Generate the invalid range message.
     * @returns {string} - invalid range string.
     * @private
     */

  }, {
    key: "_getInvalidRangeHelpText",
    value: function _getInvalidRangeHelpText() {
      var _this$props3 = this.props,
          min = _this$props3.min,
          max = _this$props3.max;
      return _I18nManager.default.t('InputNumber', 'out_of_range').replace('%(min)', min).replace('%(max)', max);
    }
    /**
     * Check if the given finite value is within range.
     * @param {string} value - must be a valid number.
     * @returns {boolean} - true if the number is within range, or false.
     * @private
     */

  }, {
    key: "_isValidRange",
    value: function _isValidRange(value) {
      if (value === '') {
        return true;
      }

      var _this$props4 = this.props,
          max = _this$props4.max,
          min = _this$props4.min;
      var numberValue = parseFloat(value);
      return numberValue <= max && numberValue >= min;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          className = _this$props5.className,
          min = _this$props5.min,
          max = _this$props5.max,
          step = _this$props5.step,
          defaultValue = _this$props5.defaultValue,
          value = _this$props5.value,
          onValueChange = _this$props5.onValueChange,
          props = _objectWithoutProperties(_this$props5, ["className", "min", "max", "step", "defaultValue", "value", "onValueChange"]);

      var numValue = parseFloat(this.state.value);
      var styleProps = {
        'data-max': numValue >= max,
        'data-min': numValue <= min
      }; // eslint-disable-next-line no-unused-vars

      var _this$state = this.state,
          controlled = _this$state.controlled,
          stateProps = _objectWithoutProperties(_this$state, ["controlled"]);

      var addonBeforeProps = _objectSpread({}, this.props.addonBeforeProps, {
        onMouseDown: this.handleOnClickMinus
      });

      var addonAfterProps = _objectSpread({}, this.props.addonAfterProps, {
        onMouseDown: this.handleOnClickAdd
      });

      var clsPrfx = _ThemeManager.default.getVar('classPrefix');

      return _react.default.createElement("div", _extends({
        className: (0, _classnames.default)(className, "".concat(clsPrfx, "-input-number ").concat(clsPrfx))
      }, styleProps), _react.default.createElement(InputWithLabel, _extends({}, props, stateProps, {
        onChange: this.handleOnInputChange,
        onKeyDown: this.handleKeyEvent,
        onBlur: this.handleOnInputBlur,
        addonBefore: _react.default.createElement(_MinusIcon.default, null),
        addonBeforeProps: addonBeforeProps,
        addonAfter: _react.default.createElement(_PlusIcon.default, {
          size: "small"
        }),
        addonAfterProps: addonAfterProps
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var value = props.value,
          error = props.error,
          helpText = props.helpText;

      if (state.controlled) {
        // User is in the middle of entering a negative number.
        if (state.value === '-') {
          return null;
        }

        return _objectSpread({}, state, {
          value: value,
          error: error,
          helpText: helpText
        });
      } // uncontrolled


      return null;
    }
    /**
     * Handling input change when user is typing in a value.
     * Only valid number passing the isFinite test is allowed.
     * @param {ReactEvent} event - input event.
     */

  }]);

  return InputNumber;
}(_react.default.Component);

exports.default = InputNumber;
InputNumber.defaultProps = {
  step: 1,
  min: Number.MIN_SAFE_INTEGER,
  max: Number.MAX_SAFE_INTEGER,
  placeholder: _I18nManager.default.t('InputNumber', 'enter_number'),
  onChange: function onChange() {
    return 0;
  }
};
InputNumber.propTypes = {
  // eslint-disable-next-line valid-jsdoc

  /**
   * A valid finite number.
   */
  // eslint-disable-next-line object-shorthand
  value: function value(props, propName, componentName) {
    var value = props.value,
        defaultValue = props.defaultValue;

    if (value && !isFinite(value) || defaultValue && !isFinite(defaultValue)) {
      return new Error("`".concat(propName, "` prop on `").concat(componentName, "` is not a finite number"));
    }

    return _PropTypesUtils.validateInputControl.apply(this, arguments);
  },

  /**
   * This must be unique across all input elements on the page
   * to ensure proper focus when label is clicked.
   */
  id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),

  /**
   * Set the minimum number value allowed
   */
  min: _propTypes.default.number,

  /**
   * Set the maximum number value allowed.
   */
  max: _propTypes.default.number,

  /**
   * Control the decrement/increment step.
   */
  step: _propTypes.default.number,

  /**
   * This is the default behavior of input change when someone typing on the
   * input field.  You should use onValueChange to capture both typing input
   * change and +/- button change.
   */
  onChange: _propTypes.default.func,

  /**
   * Callback function to handle when the value has changed.
   * onValueChange(value, error, helpText)
   * @param {string} value - This is the new changed number in type string format.
   * @param {boolean} error - True if the value violated the min max range.
   * @prarm {string} helpText - The range violation text.
   */
  onValueChange: _propTypes.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnInputChange = function (event) {
    var value = event.currentTarget.value;
    var onChange = _this2.props.onChange;

    if (value === '-') {
      // User is about to enter a negative number
      _this2.prevValidValue = _this2.state.value;

      _this2.setState({
        value: value
      });

      return;
    }

    _this2._setStateValue(value);

    if (onChange) {
      onChange(event);
    }
  };

  this.handleOnInputBlur = function (event) {
    var value = event.currentTarget.value;

    if (value === '-') {
      // If still just '-' in the input then restore
      // to the previous saved value.
      _this2.setState({
        value: _this2.prevValidValue
      });
    }
  };

  this.handleOnClickMinus = function () {
    var step = _this2.props.step;

    _this2._addOrMinus(-step);
  };

  this.handleOnClickAdd = function () {
    var step = _this2.props.step;

    _this2._addOrMinus(step);
  };

  this.handleKeyEvent = function (event) {
    var onKeyDown = _this2.props.onKeyDown;

    if (onKeyDown) {
      onKeyDown(event);
    }

    switch (event.key) {
      case 'ArrowUp':
        event.preventDefault();

        _this2.handleOnClickAdd();

        break;

      case 'ArrowDown':
        event.preventDefault();

        _this2.handleOnClickMinus();

        break;

      default:
        break;
    }
  };
};